import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lgv-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss']
})

export class LoadingIndicatorComponent implements OnInit {

  @Input() CSSClass: string = '';

  constructor() { }

  ngOnInit() {
  }

  get CalcCSSClass(): string {
      if (this.CSSClass && this.CSSClass.length > 0) {
          return this.CSSClass;
      }
      else {
          return "Default";
      }
  }

}
